// extracted by mini-css-extract-plugin
export default {"componentWrapper":"AddToShoppingListButton_componentWrapper__XwzLL","shoppingListButton":"AddToShoppingListButton_shoppingListButton__xa9vw"};